import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=13a9d6b0&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=13a9d6b0&prod&lang=scss"
import style1 from "./shopList.vue?vue&type=style&index=1&id=13a9d6b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9d6b0",
  null
  
)

export default component.exports